// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tax-view {
  border-radius: var(--ui-radius-xl);
}

.tax-summary-grid {
  gap: var(--ui-space-3);
}

.tax-summary-card {
  min-height: 144px;
}

.cfdi-secure-board {
  margin-bottom: var(--ui-space-4);
  border: 1px solid rgba(33, 86, 118, 0.16);
  background:
    radial-gradient(circle at top right, rgba(81, 137, 176, 0.12), transparent 30%),
    linear-gradient(160deg, rgba(247, 251, 254, 0.98), rgba(241, 248, 252, 0.96));
}

.cfdi-secure-header {
  margin-bottom: var(--ui-space-4);
}

.cfdi-header-status {
  display: grid;
  gap: 0.3rem;
  justify-items: end;
}

.cfdi-header-status small {
  font-size: 0.76rem;
  color: var(--ui-text-soft);
}

.cfdi-grid {
  display: grid;
  gap: var(--ui-space-4);
  grid-template-columns: minmax(0, 1.7fr) minmax(300px, 0.95fr);
  align-items: start;
}

.cfdi-form-column {
  display: grid;
  gap: var(--ui-space-4);
}

.cfdi-panel {
  border: 1px solid rgba(33, 86, 118, 0.12);
  border-radius: var(--ui-radius-lg);
  padding: var(--ui-space-5);
  background:
    linear-gradient(145deg, rgba(255, 255, 255, 0.96), rgba(247, 251, 254, 0.94));
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);
}

.cfdi-panel-credentials {
  position: relative;
}

.cfdi-panel-credentials::after {
  content: '';
  position: absolute;
  inset: auto 1.25rem 0.95rem auto;
  width: 88px;
  height: 88px;
  border-radius: 1.2rem;
  background:
    linear-gradient(135deg, rgba(29, 90, 124, 0.1), rgba(20, 114, 79, 0.08));
  pointer-events: none;
}

.cfdi-panel-execution {
  background:
    linear-gradient(145deg, rgba(250, 253, 255, 0.98), rgba(244, 249, 253, 0.96));
}

.cfdi-panel-history {
  padding-top: var(--ui-space-6);
}

.cfdi-panel-head {
  display: flex;
  justify-content: space-between;
  gap: var(--ui-space-4);
  align-items: flex-start;
  margin-bottom: var(--ui-space-4);
}

.cfdi-panel-head h4 {
  margin: 0;
  font-size: 1.02rem;
  color: var(--ui-text);
}

.cfdi-panel-head p:last-child {
  margin: 0.35rem 0 0;
  font-size: 0.86rem;
  color: var(--ui-text-soft);
}

.cfdi-kicker {
  margin: 0 0 0.35rem;
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--ui-accent);
  font-weight: 700;
}

.cfdi-panel-grid {
  display: grid;
  gap: var(--ui-space-3);
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.cfdi-span-full {
  grid-column: 1 / -1;
}

.cfdi-file-grid {
  display: grid;
  gap: var(--ui-space-3);
  grid-template-columns: repeat(2, minmax(0, 1fr));
  position: relative;
  z-index: 1;
}

.cfdi-credential-metadata {
  display: grid;
  gap: var(--ui-space-3);
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-bottom: var(--ui-space-3);
  position: relative;
  z-index: 1;
}

.cfdi-asset-status-card {
  display: grid;
  gap: 0.35rem;
  padding: 0.95rem 1rem;
  border-radius: 1rem;
  border: 1px solid rgba(33, 86, 118, 0.12);
  background: rgba(255, 255, 255, 0.86);
}

.cfdi-credential-metadata span {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--ui-text-soft);
}

.cfdi-asset-status-card strong,
.cfdi-asset-status-card small {
  overflow-wrap: anywhere;
}

.cfdi-asset-status-card strong {
  color: var(--ui-text);
  font-size: 0.92rem;
}

.cfdi-asset-status-card small {
  color: var(--ui-text-soft);
  font-size: 0.78rem;
}

.cfdi-credential-metadata > div:last-child {
  grid-column: span 2;
}

.cfdi-badge-stack {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.35rem;
}

.cfdi-file-card {
  display: grid;
  gap: 0.7rem;
  padding: 1rem;
  border-radius: 1rem;
  border: 1px solid rgba(33, 86, 118, 0.14);
  background: rgba(255, 255, 255, 0.88);
}

.cfdi-file-card input[type='file'] {
  width: 100%;
}

.cfdi-file-card.tone-success {
  border-color: rgba(20, 114, 79, 0.22);
  background: linear-gradient(145deg, rgba(246, 255, 251, 0.96), rgba(239, 249, 245, 0.94));
}

.cfdi-file-card.tone-danger {
  border-color: rgba(156, 60, 50, 0.22);
  background: linear-gradient(145deg, rgba(255, 248, 247, 0.96), rgba(252, 241, 239, 0.94));
}

.cfdi-file-label {
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--ui-text);
}

.cfdi-file-meta {
  display: grid;
  gap: 0.3rem;
}

.cfdi-file-meta strong {
  font-size: 0.93rem;
  color: var(--ui-text);
  overflow-wrap: anywhere;
}

.cfdi-file-meta small {
  color: var(--ui-text-soft);
  overflow-wrap: anywhere;
}

.cfdi-feedback-strip {
  margin: 0;
  padding: 0.85rem 1rem;
  border-radius: 0.95rem;
  border: 1px solid rgba(33, 86, 118, 0.12);
  background: rgba(255, 255, 255, 0.78);
}

.cfdi-inline-note {
  margin: 0;
  font-size: 0.84rem;
  line-height: 1.45;
  color: var(--ui-text-soft);
}

.cfdi-next-steps {
  margin-top: var(--ui-space-3);
  padding: 0.95rem 1rem;
  border-radius: 1rem;
  border: 1px solid rgba(33, 86, 118, 0.12);
  background: rgba(255, 255, 255, 0.82);
  position: relative;
  z-index: 1;
}

.cfdi-step-list {
  margin: 0;
  padding-left: 1.1rem;
  display: grid;
  gap: 0.35rem;
  color: var(--ui-text-soft);
  font-size: 0.84rem;
  line-height: 1.45;
}

.cfdi-step-list li {
  margin: 0;
}

.cfdi-actions {
  margin-top: var(--ui-space-4);
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.cfdi-actions-compact {
  align-items: center;
}

.cfdi-actions-tight {
  justify-content: flex-start;
}

.cfdi-toggle-card {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  min-height: 2.75rem;
  padding: 0.75rem 0.9rem;
  border-radius: 1rem;
  border: 1px solid rgba(33, 86, 118, 0.14);
  background: rgba(255, 255, 255, 0.84);
  color: var(--ui-text-soft);
  font-size: 0.84rem;
  line-height: 1.35;
}

.cfdi-toggle-card input[type='checkbox'] {
  width: 1rem;
  height: 1rem;
  margin: 0;
  accent-color: var(--ui-accent);
  flex: 0 0 auto;
}

.cfdi-toggle-card span {
  display: block;
}

.cfdi-toggle-card.active {
  border-color: rgba(20, 114, 79, 0.18);
  background: linear-gradient(145deg, rgba(246, 255, 251, 0.96), rgba(239, 249, 245, 0.94));
  color: var(--ui-text);
}

.cfdi-status-card,
.cfdi-panel-history {
  position: sticky;
  top: 1rem;
  padding: var(--ui-space-5);
  border: 1px solid rgba(33, 86, 118, 0.16);
  border-radius: var(--ui-radius-lg);
  background:
    linear-gradient(155deg, rgba(245, 250, 254, 0.98), rgba(237, 246, 252, 0.95));
}
.cfdi-status-grid {
  display: grid;
  gap: 0.75rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-bottom: var(--ui-space-4);
}

.cfdi-status-item {
  padding: 0.85rem 0.95rem;
  border-radius: 0.95rem;
  border: 1px solid rgba(33, 86, 118, 0.1);
  background: rgba(255, 255, 255, 0.78);
}

.cfdi-status-item span {
  display: block;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--ui-text-soft);
  margin-bottom: 0.35rem;
}

.cfdi-status-item strong {
  display: block;
  font-size: 0.94rem;
  color: var(--ui-text);
  overflow-wrap: anywhere;
}

.cfdi-status-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2rem;
  padding: 0.35rem 0.7rem;
  border-radius: var(--ui-radius-pill);
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  border: 1px solid rgba(33, 86, 118, 0.12);
  color: var(--ui-text);
  background: rgba(255, 255, 255, 0.7);
}

.cfdi-status-pill.tone-success {
  color: var(--ui-success);
  border-color: rgba(20, 114, 79, 0.2);
  background: rgba(20, 114, 79, 0.08);
}

.cfdi-status-pill.tone-warning {
  color: var(--ui-warning);
  border-color: rgba(149, 109, 21, 0.18);
  background: rgba(149, 109, 21, 0.08);
}

.cfdi-status-pill.tone-danger {
  color: var(--ui-danger);
  border-color: rgba(156, 60, 50, 0.18);
  background: rgba(156, 60, 50, 0.08);
}

.cfdi-result-list {
  border-top: 1px solid rgba(33, 86, 118, 0.08);
  padding-top: var(--ui-space-4);
}

.cfdi-result-title {
  margin: 0 0 0.55rem;
  font-size: 0.76rem;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--ui-text-soft);
  font-weight: 700;
}

.cfdi-chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.cfdi-chip {
  display: inline-flex;
  max-width: 100%;
  padding: 0.35rem 0.65rem;
  border-radius: 999px;
  background: rgba(29, 90, 124, 0.08);
  border: 1px solid rgba(29, 90, 124, 0.14);
  color: var(--ui-accent-strong);
  font-size: 0.78rem;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.cfdi-result-alert {
  margin-top: var(--ui-space-4);
}

.helper-text.success {
  color: var(--ui-success);
}

:root[data-theme='dark'] .cfdi-secure-board {
  border-color: rgba(80, 131, 164, 0.3);
  background:
    radial-gradient(circle at top right, rgba(60, 134, 177, 0.18), transparent 32%),
    linear-gradient(160deg, rgba(16, 30, 42, 0.98), rgba(12, 23, 34, 0.96));
}

:root[data-theme='dark'] .cfdi-panel,
:root[data-theme='dark'] .cfdi-status-card,
:root[data-theme='dark'] .cfdi-panel-history,
:root[data-theme='dark'] .cfdi-file-card,
:root[data-theme='dark'] .cfdi-asset-status-card,
:root[data-theme='dark'] .cfdi-status-item,
:root[data-theme='dark'] .cfdi-feedback-strip,
:root[data-theme='dark'] .cfdi-toggle-card {
  border-color: rgba(70, 115, 145, 0.34);
  background:
    linear-gradient(150deg, rgba(17, 32, 45, 0.96), rgba(12, 24, 35, 0.94));
}

:root[data-theme='dark'] .cfdi-file-card.tone-success {
  border-color: rgba(43, 160, 112, 0.3);
  background: linear-gradient(150deg, rgba(14, 39, 32, 0.96), rgba(11, 31, 26, 0.94));
}

:root[data-theme='dark'] .cfdi-file-card.tone-danger {
  border-color: rgba(187, 87, 77, 0.28);
  background: linear-gradient(150deg, rgba(43, 24, 24, 0.96), rgba(31, 19, 19, 0.94));
}

:root[data-theme='dark'] .cfdi-toggle-card.active {
  border-color: rgba(43, 160, 112, 0.3);
  background: linear-gradient(150deg, rgba(14, 39, 32, 0.96), rgba(11, 31, 26, 0.94));
}

:root[data-theme='dark'] .cfdi-panel-head h4,
:root[data-theme='dark'] .cfdi-file-label,
:root[data-theme='dark'] .cfdi-asset-status-card strong,
:root[data-theme='dark'] .cfdi-file-meta strong,
:root[data-theme='dark'] .cfdi-status-item strong {
  color: #f0f7fc;
}

:root[data-theme='dark'] .cfdi-panel-head p:last-child,
:root[data-theme='dark'] .cfdi-header-status small,
:root[data-theme='dark'] .cfdi-inline-note,
:root[data-theme='dark'] .cfdi-step-list,
:root[data-theme='dark'] .cfdi-asset-status-card span,
:root[data-theme='dark'] .cfdi-asset-status-card small,
:root[data-theme='dark'] .cfdi-file-meta small,
:root[data-theme='dark'] .cfdi-toggle-card,
:root[data-theme='dark'] .cfdi-status-item span,
:root[data-theme='dark'] .cfdi-result-title {
  color: #9db5c6;
}

:root[data-theme='dark'] .cfdi-kicker,
:root[data-theme='dark'] .cfdi-chip {
  color: #8ec5e7;
}

:root[data-theme='dark'] .cfdi-chip {
  border-color: rgba(84, 154, 197, 0.28);
  background: rgba(42, 98, 130, 0.22);
}

@media (max-width: 960px) {
  .tax-controls {
    gap: 0.65rem;
  }

  .tax-main-panel {
    padding: 0.85rem;
  }

  .cfdi-grid {
    grid-template-columns: 1fr;
  }

  .cfdi-status-card,
  .cfdi-panel-history {
    position: static;
  }

  .cfdi-panel-grid {
    grid-template-columns: 1fr;
  }

  .cfdi-file-grid {
    grid-template-columns: 1fr;
  }

  .cfdi-credential-metadata {
    grid-template-columns: 1fr;
  }

  .cfdi-credential-metadata > div:last-child {
    grid-column: auto;
  }

  .cfdi-status-grid {
    grid-template-columns: 1fr;
  }

  .cfdi-panel,
  .cfdi-status-card,
  .cfdi-panel-history {
    padding: 1rem;
  }
}

@media (max-width: 640px) {
  .cfdi-panel-head,
  .cfdi-secure-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .cfdi-header-status {
    justify-items: start;
  }

  .cfdi-actions {
    flex-direction: column;
  }

  .cfdi-actions .btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/views-impuestos.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,yCAAyC;EACzC;;iFAE+E;AACjF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,kCAAkC;EAClC,0BAA0B;EAC1B;iFAC+E;EAC/E,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB;4EAC0E;EAC1E,oBAAoB;AACtB;;AAEA;EACE;iFAC+E;AACjF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gDAAgD;EAChD,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gDAAgD;EAChD,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,yFAAyF;AAC3F;;AAEA;EACE,qCAAqC;EACrC,yFAAyF;AAC3F;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,sBAAsB;EACtB,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,yCAAyC;EACzC,qCAAqC;EACrC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,yFAAyF;EACzF,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,0BAA0B;EAC1B,yCAAyC;EACzC,kCAAkC;EAClC;iFAC+E;AACjF;AACA;EACE,aAAa;EACb,YAAY;EACZ,gDAAgD;EAChD,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yCAAyC;EACzC,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,6CAA6C;EAC7C,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,wBAAwB;EACxB,oBAAoB;EACpB,mCAAmC;EACnC,yCAAyC;EACzC,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC;;2EAEyE;AAC3E;;AAEA;;;;;;;;EAQE,sCAAsC;EACtC;2EACyE;AAC3E;;AAEA;EACE,qCAAqC;EACrC,mFAAmF;AACrF;;AAEA;EACE,qCAAqC;EACrC,mFAAmF;AACrF;;AAEA;EACE,qCAAqC;EACrC,mFAAmF;AACrF;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;;;;;;;EAUE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".tax-view {\n  border-radius: var(--ui-radius-xl);\n}\n\n.tax-summary-grid {\n  gap: var(--ui-space-3);\n}\n\n.tax-summary-card {\n  min-height: 144px;\n}\n\n.cfdi-secure-board {\n  margin-bottom: var(--ui-space-4);\n  border: 1px solid rgba(33, 86, 118, 0.16);\n  background:\n    radial-gradient(circle at top right, rgba(81, 137, 176, 0.12), transparent 30%),\n    linear-gradient(160deg, rgba(247, 251, 254, 0.98), rgba(241, 248, 252, 0.96));\n}\n\n.cfdi-secure-header {\n  margin-bottom: var(--ui-space-4);\n}\n\n.cfdi-header-status {\n  display: grid;\n  gap: 0.3rem;\n  justify-items: end;\n}\n\n.cfdi-header-status small {\n  font-size: 0.76rem;\n  color: var(--ui-text-soft);\n}\n\n.cfdi-grid {\n  display: grid;\n  gap: var(--ui-space-4);\n  grid-template-columns: minmax(0, 1.7fr) minmax(300px, 0.95fr);\n  align-items: start;\n}\n\n.cfdi-form-column {\n  display: grid;\n  gap: var(--ui-space-4);\n}\n\n.cfdi-panel {\n  border: 1px solid rgba(33, 86, 118, 0.12);\n  border-radius: var(--ui-radius-lg);\n  padding: var(--ui-space-5);\n  background:\n    linear-gradient(145deg, rgba(255, 255, 255, 0.96), rgba(247, 251, 254, 0.94));\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);\n}\n\n.cfdi-panel-credentials {\n  position: relative;\n}\n\n.cfdi-panel-credentials::after {\n  content: '';\n  position: absolute;\n  inset: auto 1.25rem 0.95rem auto;\n  width: 88px;\n  height: 88px;\n  border-radius: 1.2rem;\n  background:\n    linear-gradient(135deg, rgba(29, 90, 124, 0.1), rgba(20, 114, 79, 0.08));\n  pointer-events: none;\n}\n\n.cfdi-panel-execution {\n  background:\n    linear-gradient(145deg, rgba(250, 253, 255, 0.98), rgba(244, 249, 253, 0.96));\n}\n\n.cfdi-panel-history {\n  padding-top: var(--ui-space-6);\n}\n\n.cfdi-panel-head {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--ui-space-4);\n  align-items: flex-start;\n  margin-bottom: var(--ui-space-4);\n}\n\n.cfdi-panel-head h4 {\n  margin: 0;\n  font-size: 1.02rem;\n  color: var(--ui-text);\n}\n\n.cfdi-panel-head p:last-child {\n  margin: 0.35rem 0 0;\n  font-size: 0.86rem;\n  color: var(--ui-text-soft);\n}\n\n.cfdi-kicker {\n  margin: 0 0 0.35rem;\n  font-size: 0.72rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--ui-accent);\n  font-weight: 700;\n}\n\n.cfdi-panel-grid {\n  display: grid;\n  gap: var(--ui-space-3);\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.cfdi-span-full {\n  grid-column: 1 / -1;\n}\n\n.cfdi-file-grid {\n  display: grid;\n  gap: var(--ui-space-3);\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  position: relative;\n  z-index: 1;\n}\n\n.cfdi-credential-metadata {\n  display: grid;\n  gap: var(--ui-space-3);\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  margin-bottom: var(--ui-space-3);\n  position: relative;\n  z-index: 1;\n}\n\n.cfdi-asset-status-card {\n  display: grid;\n  gap: 0.35rem;\n  padding: 0.95rem 1rem;\n  border-radius: 1rem;\n  border: 1px solid rgba(33, 86, 118, 0.12);\n  background: rgba(255, 255, 255, 0.86);\n}\n\n.cfdi-credential-metadata span {\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: var(--ui-text-soft);\n}\n\n.cfdi-asset-status-card strong,\n.cfdi-asset-status-card small {\n  overflow-wrap: anywhere;\n}\n\n.cfdi-asset-status-card strong {\n  color: var(--ui-text);\n  font-size: 0.92rem;\n}\n\n.cfdi-asset-status-card small {\n  color: var(--ui-text-soft);\n  font-size: 0.78rem;\n}\n\n.cfdi-credential-metadata > div:last-child {\n  grid-column: span 2;\n}\n\n.cfdi-badge-stack {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.35rem;\n}\n\n.cfdi-file-card {\n  display: grid;\n  gap: 0.7rem;\n  padding: 1rem;\n  border-radius: 1rem;\n  border: 1px solid rgba(33, 86, 118, 0.14);\n  background: rgba(255, 255, 255, 0.88);\n}\n\n.cfdi-file-card input[type='file'] {\n  width: 100%;\n}\n\n.cfdi-file-card.tone-success {\n  border-color: rgba(20, 114, 79, 0.22);\n  background: linear-gradient(145deg, rgba(246, 255, 251, 0.96), rgba(239, 249, 245, 0.94));\n}\n\n.cfdi-file-card.tone-danger {\n  border-color: rgba(156, 60, 50, 0.22);\n  background: linear-gradient(145deg, rgba(255, 248, 247, 0.96), rgba(252, 241, 239, 0.94));\n}\n\n.cfdi-file-label {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--ui-text);\n}\n\n.cfdi-file-meta {\n  display: grid;\n  gap: 0.3rem;\n}\n\n.cfdi-file-meta strong {\n  font-size: 0.93rem;\n  color: var(--ui-text);\n  overflow-wrap: anywhere;\n}\n\n.cfdi-file-meta small {\n  color: var(--ui-text-soft);\n  overflow-wrap: anywhere;\n}\n\n.cfdi-feedback-strip {\n  margin: 0;\n  padding: 0.85rem 1rem;\n  border-radius: 0.95rem;\n  border: 1px solid rgba(33, 86, 118, 0.12);\n  background: rgba(255, 255, 255, 0.78);\n}\n\n.cfdi-inline-note {\n  margin: 0;\n  font-size: 0.84rem;\n  line-height: 1.45;\n  color: var(--ui-text-soft);\n}\n\n.cfdi-next-steps {\n  margin-top: var(--ui-space-3);\n  padding: 0.95rem 1rem;\n  border-radius: 1rem;\n  border: 1px solid rgba(33, 86, 118, 0.12);\n  background: rgba(255, 255, 255, 0.82);\n  position: relative;\n  z-index: 1;\n}\n\n.cfdi-step-list {\n  margin: 0;\n  padding-left: 1.1rem;\n  display: grid;\n  gap: 0.35rem;\n  color: var(--ui-text-soft);\n  font-size: 0.84rem;\n  line-height: 1.45;\n}\n\n.cfdi-step-list li {\n  margin: 0;\n}\n\n.cfdi-actions {\n  margin-top: var(--ui-space-4);\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.cfdi-actions-compact {\n  align-items: center;\n}\n\n.cfdi-actions-tight {\n  justify-content: flex-start;\n}\n\n.cfdi-toggle-card {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-height: 2.75rem;\n  padding: 0.75rem 0.9rem;\n  border-radius: 1rem;\n  border: 1px solid rgba(33, 86, 118, 0.14);\n  background: rgba(255, 255, 255, 0.84);\n  color: var(--ui-text-soft);\n  font-size: 0.84rem;\n  line-height: 1.35;\n}\n\n.cfdi-toggle-card input[type='checkbox'] {\n  width: 1rem;\n  height: 1rem;\n  margin: 0;\n  accent-color: var(--ui-accent);\n  flex: 0 0 auto;\n}\n\n.cfdi-toggle-card span {\n  display: block;\n}\n\n.cfdi-toggle-card.active {\n  border-color: rgba(20, 114, 79, 0.18);\n  background: linear-gradient(145deg, rgba(246, 255, 251, 0.96), rgba(239, 249, 245, 0.94));\n  color: var(--ui-text);\n}\n\n.cfdi-status-card,\n.cfdi-panel-history {\n  position: sticky;\n  top: 1rem;\n  padding: var(--ui-space-5);\n  border: 1px solid rgba(33, 86, 118, 0.16);\n  border-radius: var(--ui-radius-lg);\n  background:\n    linear-gradient(155deg, rgba(245, 250, 254, 0.98), rgba(237, 246, 252, 0.95));\n}\n.cfdi-status-grid {\n  display: grid;\n  gap: 0.75rem;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  margin-bottom: var(--ui-space-4);\n}\n\n.cfdi-status-item {\n  padding: 0.85rem 0.95rem;\n  border-radius: 0.95rem;\n  border: 1px solid rgba(33, 86, 118, 0.1);\n  background: rgba(255, 255, 255, 0.78);\n}\n\n.cfdi-status-item span {\n  display: block;\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: var(--ui-text-soft);\n  margin-bottom: 0.35rem;\n}\n\n.cfdi-status-item strong {\n  display: block;\n  font-size: 0.94rem;\n  color: var(--ui-text);\n  overflow-wrap: anywhere;\n}\n\n.cfdi-status-pill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 2rem;\n  padding: 0.35rem 0.7rem;\n  border-radius: var(--ui-radius-pill);\n  font-size: 0.74rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  border: 1px solid rgba(33, 86, 118, 0.12);\n  color: var(--ui-text);\n  background: rgba(255, 255, 255, 0.7);\n}\n\n.cfdi-status-pill.tone-success {\n  color: var(--ui-success);\n  border-color: rgba(20, 114, 79, 0.2);\n  background: rgba(20, 114, 79, 0.08);\n}\n\n.cfdi-status-pill.tone-warning {\n  color: var(--ui-warning);\n  border-color: rgba(149, 109, 21, 0.18);\n  background: rgba(149, 109, 21, 0.08);\n}\n\n.cfdi-status-pill.tone-danger {\n  color: var(--ui-danger);\n  border-color: rgba(156, 60, 50, 0.18);\n  background: rgba(156, 60, 50, 0.08);\n}\n\n.cfdi-result-list {\n  border-top: 1px solid rgba(33, 86, 118, 0.08);\n  padding-top: var(--ui-space-4);\n}\n\n.cfdi-result-title {\n  margin: 0 0 0.55rem;\n  font-size: 0.76rem;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: var(--ui-text-soft);\n  font-weight: 700;\n}\n\n.cfdi-chip-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.cfdi-chip {\n  display: inline-flex;\n  max-width: 100%;\n  padding: 0.35rem 0.65rem;\n  border-radius: 999px;\n  background: rgba(29, 90, 124, 0.08);\n  border: 1px solid rgba(29, 90, 124, 0.14);\n  color: var(--ui-accent-strong);\n  font-size: 0.78rem;\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n\n.cfdi-result-alert {\n  margin-top: var(--ui-space-4);\n}\n\n.helper-text.success {\n  color: var(--ui-success);\n}\n\n:root[data-theme='dark'] .cfdi-secure-board {\n  border-color: rgba(80, 131, 164, 0.3);\n  background:\n    radial-gradient(circle at top right, rgba(60, 134, 177, 0.18), transparent 32%),\n    linear-gradient(160deg, rgba(16, 30, 42, 0.98), rgba(12, 23, 34, 0.96));\n}\n\n:root[data-theme='dark'] .cfdi-panel,\n:root[data-theme='dark'] .cfdi-status-card,\n:root[data-theme='dark'] .cfdi-panel-history,\n:root[data-theme='dark'] .cfdi-file-card,\n:root[data-theme='dark'] .cfdi-asset-status-card,\n:root[data-theme='dark'] .cfdi-status-item,\n:root[data-theme='dark'] .cfdi-feedback-strip,\n:root[data-theme='dark'] .cfdi-toggle-card {\n  border-color: rgba(70, 115, 145, 0.34);\n  background:\n    linear-gradient(150deg, rgba(17, 32, 45, 0.96), rgba(12, 24, 35, 0.94));\n}\n\n:root[data-theme='dark'] .cfdi-file-card.tone-success {\n  border-color: rgba(43, 160, 112, 0.3);\n  background: linear-gradient(150deg, rgba(14, 39, 32, 0.96), rgba(11, 31, 26, 0.94));\n}\n\n:root[data-theme='dark'] .cfdi-file-card.tone-danger {\n  border-color: rgba(187, 87, 77, 0.28);\n  background: linear-gradient(150deg, rgba(43, 24, 24, 0.96), rgba(31, 19, 19, 0.94));\n}\n\n:root[data-theme='dark'] .cfdi-toggle-card.active {\n  border-color: rgba(43, 160, 112, 0.3);\n  background: linear-gradient(150deg, rgba(14, 39, 32, 0.96), rgba(11, 31, 26, 0.94));\n}\n\n:root[data-theme='dark'] .cfdi-panel-head h4,\n:root[data-theme='dark'] .cfdi-file-label,\n:root[data-theme='dark'] .cfdi-asset-status-card strong,\n:root[data-theme='dark'] .cfdi-file-meta strong,\n:root[data-theme='dark'] .cfdi-status-item strong {\n  color: #f0f7fc;\n}\n\n:root[data-theme='dark'] .cfdi-panel-head p:last-child,\n:root[data-theme='dark'] .cfdi-header-status small,\n:root[data-theme='dark'] .cfdi-inline-note,\n:root[data-theme='dark'] .cfdi-step-list,\n:root[data-theme='dark'] .cfdi-asset-status-card span,\n:root[data-theme='dark'] .cfdi-asset-status-card small,\n:root[data-theme='dark'] .cfdi-file-meta small,\n:root[data-theme='dark'] .cfdi-toggle-card,\n:root[data-theme='dark'] .cfdi-status-item span,\n:root[data-theme='dark'] .cfdi-result-title {\n  color: #9db5c6;\n}\n\n:root[data-theme='dark'] .cfdi-kicker,\n:root[data-theme='dark'] .cfdi-chip {\n  color: #8ec5e7;\n}\n\n:root[data-theme='dark'] .cfdi-chip {\n  border-color: rgba(84, 154, 197, 0.28);\n  background: rgba(42, 98, 130, 0.22);\n}\n\n@media (max-width: 960px) {\n  .tax-controls {\n    gap: 0.65rem;\n  }\n\n  .tax-main-panel {\n    padding: 0.85rem;\n  }\n\n  .cfdi-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .cfdi-status-card,\n  .cfdi-panel-history {\n    position: static;\n  }\n\n  .cfdi-panel-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .cfdi-file-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .cfdi-credential-metadata {\n    grid-template-columns: 1fr;\n  }\n\n  .cfdi-credential-metadata > div:last-child {\n    grid-column: auto;\n  }\n\n  .cfdi-status-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .cfdi-panel,\n  .cfdi-status-card,\n  .cfdi-panel-history {\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 640px) {\n  .cfdi-panel-head,\n  .cfdi-secure-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .cfdi-header-status {\n    justify-items: start;\n  }\n\n  .cfdi-actions {\n    flex-direction: column;\n  }\n\n  .cfdi-actions .btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
